// extracted by mini-css-extract-plugin
module.exports = {"keyContainer":"Key_keyContainer__tmbko","backspace":"Key_backspace__1U07E"};